export const cols = [{
	prop: 'customername',
	label: '客户名称',
	width: '',
	ischoose: true,
	disabled: true,
	sortable: false,
	align: 'center'
}, {
	prop: 'customercategoryname',
	label: '客户类别',
	width: '',
	ischoose: true,
	sortable: false,
	align: 'center'
}, {
	prop: 'pname',
	label: '商品名称',
	width: '',
	ischoose: true,
	sortable: false,
	align: 'center'
}, {
	prop: 'spec',
	label: '规格',
	width: '',
	ischoose: true,
	sortable: false,
	align: 'center'
}, {
	prop: 'matchCode',
	label: '第三方编号',
	width: '180',
	ischoose: false,
	headerAlign: 'center',
	sortable: false,
	align: 'right'
}, {
	prop: 'orderidcount',
	label: '订单数量',
	width: '',
	ischoose: true,
	headerAlign: 'center',
	sortable: true,
	align: 'right'
}, {
	prop: 'livequantity',
	label: '订单商品数量',
	width: '',
	ischoose: true,
	headerAlign: 'center',
	sortable: true,
	align: 'right'
}, {
	prop: 'livemoney',
	label: '订单商品金额',
	width: '',
	ischoose: true,
	headerAlign: 'center',
	sortable: true,
	align: 'right'
}, {
	prop: 'refundidcount',
	label: '退单数量',
	width: '',
	ischoose: true,
	headerAlign: 'center',
	sortable: true,
	align: 'right'
}, {
	prop: 'refundquantity',
	label: '退单商品数量',
	width: '',
	ischoose: true,
	headerAlign: 'center',
	sortable: true,
	align: 'right'
}, {
	prop: 'refundmoney',
	label: '退单商品金额',
	width: '',
	ischoose: true,
	headerAlign: 'center',
	sortable: true,
	align: 'right'
}]
